import { render, staticRenderFns } from "./NameWithSignatureRow.vue?vue&type=template&id=455be3d2&scoped=true"
import script from "./NameWithSignatureRow.vue?vue&type=script&lang=js"
export * from "./NameWithSignatureRow.vue?vue&type=script&lang=js"
import style0 from "./NameWithSignatureRow.vue?vue&type=style&index=0&id=455be3d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455be3d2",
  null
  
)

export default component.exports